import React from 'react';
import type { AccidentDetailData } from './constants';
import BasicInfoBlock from './blocks/BasicInfoBlock';
import HandlePlanBlock from './blocks/HandlePlanBlock';
import VendorFeedbackBlock from './blocks/VendorFeedbackBlock';

/**
 * 事故详情页主体：业务区块（FormCard 纵向堆叠）。
 * 关联供应商、关联单、关联合同编号已内嵌于基本信息区块；数据由 index.tsx 通过 props 注入，纯展示无自身请求。
 * 仅卡片之间间距固定 16px（FormCard 自带 :not(:last-child) margin-bottom，容器不再叠 gap），
 * 四周外圈 padding 保持 p-4 不动。
 */
const ContentBox = ({ data }: { data?: AccidentDetailData }) => (
  <div className="p-4">
    <div className="flex flex-col">
      <BasicInfoBlock detail={data} />
      <HandlePlanBlock detail={data?.handlePlan} />
      <VendorFeedbackBlock detail={data?.vendorFeedback} />
    </div>
  </div>
);

export default ContentBox;
